export const FETCH_QUERY_KEYS = {
  DASHBOARD_SETTINGS: "dashboardSettings",
  COLLECTIONS: "collections",
  COLLECTION: "collection",
  ASSISTANT_AVAILABLE_DATA: "collectionAvailableData",
  ASSISTANT_LANGUAGES: "assistantLanguages",
  ASSISTANT_DEFAULT_SETTINGS: "defaultSettings",
  COLLECTION_REFS: "collectionRefs",
  ASSISTANT: "assistant",
  ACCOUNT_ASSISTANTS: "accountAssistants",
  DRAFT: "draft",
  EXTERNAL_PREVIEW: "externalPreview",
  EXTERNAL_PREVIEW_LINK: "externalPreviewLink",
  INSIGHTS: "insights",
  ANALYTICS_OVERVIEW: "analyticsOverview",
  ANALYTICS_OVERVIEW_ROUTES: "analyticsOverviewRoutes",
  ANALYTICS_OVERVIEW_INSIGHTS: "analyticsOverviewInsights",
  SENTIMENT_SUMMARY: "sentimentSummary",
  SENTIMENT_ROUTES: "sentimentRoutes",
  SENTIMENT_BUCKETS: "sentimentBuckets",
  ACTIONABLE_INSIGHTS: "insightsHomeBanner",
  ASSISTANT_TEMPLATES: "assistantTemplates",
  SUPPORTED_LANGUAGES: "supportedLanguages",
  PHONE_NUMBERS_METADATA: "phoneNumbersMetadata",
  PERMISSIONS: "permissions",
  CAMPAIGN_MANAGER: "campaignManager",
  CAMPAIGN_MANAGER_TASKS: "campaignManagerTasks",
  ALL_CAMPAIGNS: "allCampaigns",
  CAMPAIGN: "campaign",
  OUTBOUND_FILTER_TYPES: "outboundFilterTypes",
  CONVERSATION_INSIGHTS: "conversationInsights",
  CONVERSATION_UTTERANCE_COUNT: "conversationUtteranceCount",
  VALIDATION_RESULTS: "validationResults",
  VERTICAL_TYPES: "verticalTypes",
  ALL_ASSISTANTS_DATA: "allAssistantsData",
  OPEN_DRAFTS: "openDrafts",
  DRAFT_OWNERS: "draftOwners",
  FAILURES: "failures",
  POLICIES_LINKED_DATA: "policiesLinkedData",
  ASSISTANT_KNOWLEDGE: "assistantKnowledge",
  DATA_MAPPINGS_TABLES: "dataMappingsTables",
  DATA_MAPPING_TABLE: "dataMappingTable",
  ASSISTANT_CONFIGURATION: "assistantConfiguration",
  EARCON_TYPES: "earconTypes",
  DEPLOYMENT_SETTINGS: "deploymentSettings",
  PREVIEW_BRANCH_DEPLOYER: "previewBranchDeployer",
  GENERATE_SPEECH: "generateSpeech",
  CHANNEL_SETTINGS: "channelSettings",
  EVENTS_VALUE_OPTIONS: "eventsValueOptions",
  SFTP_SETTINGS: "sftpSettings",
  ACCOUNT_SETTINGS: "accountSettings",
  ACCOUNT_SETTINGS_SFTP: "accountSettingsSftp",
  CALL_ME_SITES: "callMeSites",
  CALL_ME_BUSINESS_HOURS: "callMeBusinessHours",
  ASSISTANTS_FEATURES: "assistantsFeatures",
  SUBSCRIPTION: "subscription",
  EXPRESSION_VARIABLES: "expressionVariables",
  CONFIGURABLE_CONTENT: "configurableContent",
  EXPLORE_INTROSPECTION: "exploreIntrospection",
  EXPLORE_VERSIONS: "exploreVersions",
  EXPLORE_DATA: "exploreData",
  BENCHMARKS_SETUP: "benchmarksSetup",
  ALL_SETUPS: "allSetups",
  BENCHMARK_DEFAULTS: "benchmarkDefaults",
  BENCHMARK_OVERRIDES: "benchmarkOverrides",
  VALUE_REFERENCE_DEFAULTS: "valueReferenceDefaults",
  VALUE_REFERENCE_OVERRIDES: "valueReferenceOverrides",
  CLINIC_AVAILABILITY: "clinicAvailability",
  CLINIC_AVAILABILITY_VALIDATE: "clinicAvailabilityValidate"
};
